import {Color, Size} from './types'

export const getColorVariant = (
  currentColor: Color,
  variants: {
    primary: string
    panelIconPrimary?: string
    secondary: string
    panelIconSecondary?: string
    error: string
    warning: string
    grey: string
    invert: string
  }
): string => {
  const {primary, secondary, error, warning, grey, invert} = variants
  const {panelIconPrimary, panelIconSecondary} = variants
  switch (currentColor) {
    case 'primary':
      return primary
    case 'panelIconPrimary':
      return panelIconPrimary ?? ''
    case 'secondary':
      return secondary
    case 'panelIconSecondary':
      return panelIconSecondary ?? ''
    case 'error':
      return error
    case 'warning':
      return warning
    case 'grey':
      return grey
    case 'invert':
      return invert
    default:
      throw Error(`Unsupported button color: ${currentColor}`)
  }
}

export const getSizeVariant = <T,>(
  currentSize: Size,
  variants: {small: T; medium: T; big: T}
): T => {
  const {small, medium, big} = variants
  switch (currentSize) {
    case 'small':
      return small
    case 'medium':
      return medium
    case 'big':
      return big
    default:
      throw Error(`Unsupported button size: ${currentSize}`)
  }
}
